import * as DSAssetFamilies from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { Map as ImmutableMap } from 'immutable';
import { getMetadataValue } from '../../../utils/frameworkBuilder';
import { isUnifiedEventObjectTypeId } from 'customer-data-filters-ui/filterQueryFormat/ObjectTypeId';
import Adapter from './Adapter';
import HttpAdapterConfig from '../adapterConfigs/HttpAdapterConfig';
import { FrameworkBuilderTypeMetadataRecord } from './UnifiedEventsAdapter';
export class WebVisitorsUnifiedEventsAdapterConfig extends HttpAdapterConfig {
  constructor(...args) {
    super(...args);
    this.performanceTrackingKey = 'WebVisitorsUnifiedEventsAdapter';
  }
  getCacheKey() {
    return DSAssetFamilies.WEB_VISITOR_SEGMENT_EVENT;
  }
  isAssetFamilySupported(assetFamily) {
    return assetFamily === DSAssetFamilies.WEB_VISITOR_SEGMENT_EVENT;
  }
  fetchData(httpClient) {
    return httpClient('framework-builder/v1/read/metadata/types/webVisitorSegmentEvents', {
      query: {
        transformGateValues: true
      }
    });
  }
  formatData(webVisitorsUnifiedEvents) {
    return Object.entries(webVisitorsUnifiedEvents).reduce((acc, [key, {
      metadata
    }]) => {
      const objectTypeId = getMetadataValue(metadata.objectTypeId);
      if (isUnifiedEventObjectTypeId(objectTypeId)) {
        var _getMetadataValue;
        const {
          categoryGroupLabel,
          categoryGroupName,
          gates,
          singularForm,
          scopes
        } = metadata;
        return acc.set(objectTypeId, FrameworkBuilderTypeMetadataRecord({
          categoryGroupLabel: getMetadataValue(categoryGroupLabel),
          categoryGroupName: getMetadataValue(categoryGroupName),
          fullyQualifiedName: key,
          isUngated: (_getMetadataValue = getMetadataValue(gates)) !== null && _getMetadataValue !== void 0 ? _getMetadataValue : true,
          label: getMetadataValue(singularForm) || key,
          scopes: getMetadataValue(scopes) || [],
          objectTypeId,
          requiredObjectTypeIds: getMetadataValue(metadata.requiredObjectTypeIds) || []
        }));
      }
      return acc;
    }, ImmutableMap());
  }
}
export default Adapter.makeFromConfig(WebVisitorsUnifiedEventsAdapterConfig);